import { getLoginCaptcha } from 'affiny-core/redux/selectors/configSelectors';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../../state';
import { authActions } from '../actions';
import { ILoginPayload } from '../types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  login: (payload: ILoginPayload) => dispatch(authActions.login(payload)),
});

const mapStateToProps = (state: IRootState) => ({
  captcha: getLoginCaptcha(state),
});

export type ILoginContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export const loginContainerFactory = connect(
  mapStateToProps,
  mapDispatchToProps
);
